import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import {
  Tabs,
  Tab,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import NewTravelersList from "../../features/travelers/newTravelersList";
import NewTravelersFilter from "../../features/travelers/newTravelersFilter";
import ApprovedTravelersList from "../../features/travelers/approvedTravelersList";
import RejectedTravelersList from "../../features/travelers/rejectedTravelersList";
import ApprovedTravelersFilter from "../../features/travelers/approvedTravelersFilter";
import RejectedTravelersFilter from "../../features/travelers/rejectedTravelersFilter";
import { GridColDef, useGridApiRef } from "@mui/x-data-grid";
import {
  useLazyGetTravelerQuery,
  useUpdateTravelNotificationMutation,
} from "../../services/travelers";
import { showError } from "../../constants/toasts";
import { DateRange } from "@mui/x-date-pickers-pro/internals/models";
import Loader from "../../constants/Loader";
import useAuth from "../../hooks/useAuth";
import { ADMIN_ROLE_ID } from "../../constants/role";
import secureLocalStorage from "react-secure-storage";
import { useGetCitiesQuery } from "../../services/profile";
import { BreakfastDining, Info } from "@mui/icons-material";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value == index && <>{children}</>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const Travelers = () => {
  const user = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [hidden, setHidden] = useState<string[]>([]);
  const [openModal, setOpenModal] = useState(false);
  const [selectedId, setSelectedId] = useState<string>("");
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState<string>("");
  const [totalCount, setTotalCount] = useState<number>(0);
  const [page, setPage] = useState(1);
  const [type, setType] = useState(1);
  const [getAllData] = useLazyGetTravelerQuery();
  const [travelers, setTravelers] = useState<any>([]);

  const [selectedRow, setSelectedRow] = useState<any>({
    row: [],
    column: [],
  });
  const {
    isLoading: loader,
    isError,
    data: placesData,
    isSuccess,
  } = useGetCitiesQuery({});
  if (isError) {
    showError("Something went wrong with places api");
  }
  const gridApi = useGridApiRef();

  const [valueTabs, setValueTabs] = React.useState(0);
  const [updateNotificationRead] = useUpdateTravelNotificationMutation();
  const [totalDataCount, setTotalDataCount] = useState({
    type1: 0,
    type2: 0,
    type3: 0,
    type4: 0,
  });
  const [cancelTravelCount, setCancelTravelCount] = useState(0);
  const [totalTravelCount, settotalTravelCount] = useState(0);
  const readCancelShipmentNotification = async () => {
    try {
      const response = await updateNotificationRead({}).unwrap();
      if (response?.statusCode == 200) {
        console.log("cancel travel notification count reset");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const [dateValue, setDateValue] = React.useState<any>([null, null]);

  const [arrivalCities, setArrivalCities] = useState<any>([]);

  const [departureCities, setDepartureCities] = useState<any>([]);
  const [selectedArrivalCities, setSelectedArrivalCities] = useState<any>([]);
  const [selectedDepartureCities, setSelectedDepartureCities] = useState<any>(
    []
  );

  const getAllDataList = async () => {
    try {
      setIsLoading(true);
      const response = await getAllData({
        page: 1,
        type: type,
        query: "",
      }).unwrap();
      if (response?.statusCode == 200) {
        const responseData = response?.data?.data ?? response?.data?.travel;
        setTravelers(responseData);
        console.log("response?.data?.cancelTravelCount :", response?.data);
        setCancelTravelCount(response?.data?.cancelTravelCount || 0);
        settotalTravelCount(response?.data?.totalTravellerCount || 0);
        if (type == 2) {
          let departureCities = [];
          if (Array.isArray(responseData)) {
            for (let key of responseData) {
              let flag = 0;
              for (let key2 of departureCities) {
                if (
                  key2.name?.toLowerCase()?.trim() ==
                    key?.currentAddress?.city?.toLowerCase()?.trim() &&
                  key2.country?.toLowerCase()?.trim() ==
                    key?.currentAddress?.district?.toLowerCase()?.trim()
                ) {
                  flag = 1;
                }
              }
              if (flag == 0)
                departureCities.push({
                  name: key?.currentAddress?.city?.toLowerCase()?.trim(),
                  country: key?.currentAddress?.district?.toLowerCase()?.trim(),
                  isSelected: false,
                });
            }

            let arrivalCities = [];
            for (let key of responseData) {
              let flag = 0;
              for (let key2 of arrivalCities) {
                if (
                  key2.name?.toLowerCase()?.trim() ==
                    key?.destinationAddress?.[
                      key?.destinationAddress?.length - 1
                    ]?.city
                      ?.toLowerCase()
                      ?.trim() &&
                  key2.country?.toLowerCase()?.trim() ==
                    key?.destinationAddress?.[
                      key?.destinationAddress?.length - 1
                    ]?.district
                      ?.toLowerCase()
                      ?.trim()
                ) {
                  flag = 1;
                }
              }
              if (flag == 0)
                arrivalCities.push({
                  name: key?.destinationAddress?.[
                    key?.destinationAddress?.length - 1
                  ]?.city
                    ?.toLowerCase()
                    ?.trim(),
                  country: key?.destinationAddress?.[
                    key?.destinationAddress?.length - 1
                  ]?.district
                    ?.toLowerCase()
                    ?.trim(),
                  isSelected: false,
                });
            }
          }

          // setArrivalCities(arrivalCities);
          // setArrivalCities(arrivalCities);
          // setDepartureCities(departureCities);
        }
      }
    } catch (error: any) {
      console.log("error :", error);
      showError(error?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (placesData) {
      setArrivalCities([
        ...placesData?.data?.map(
          (data: { city: string; country: string; id: number }) => ({
            name: data?.city,
            country: data?.country,
            isSelected: false,
            id: data?.id,
          })
        ),
        ...placesData?.data?.map(
          (data: { city_ar: string; country_ar: string; id: number }) => ({
            name: data?.city_ar,
            country: data?.country_ar,
            isSelected: false,
            id: data?.id,
          })
        ),
      ]);
      setDepartureCities([
        ...placesData?.data?.map(
          (data: { city: string; country: string; id: number }) => ({
            name: data?.city,
            country: data?.country,
            isSelected: false,
            id: data?.id,
          })
        ),
        ...placesData?.data?.map(
          (data: { city_ar: string; country_ar: string; id: number }) => ({
            name: data?.city_ar,
            country: data?.country_ar,
            isSelected: false,
            id: data?.id,
          })
        ),
      ]);
    }
  }, [placesData]);
  const getAllDataListTotalCount = async (type: number) => {
    try {
      const response = await getAllData({
        page: 0,
        type: type,
        query: "",
      }).unwrap();
      if (response?.statusCode == 200) {
        if (type == 1) {
          setTotalDataCount((prevData: any) => {
            return { ...prevData, type1: response?.data?.count };
          });
        } else if (type == 2) {
          setTotalDataCount((prevData: any) => {
            return { ...prevData, type2: response?.data?.count };
          });
        } else if (type == 3) {
          setTotalDataCount((prevData: any) => {
            return { ...prevData, type3: response?.data?.count };
          });
        } else {
          setTotalDataCount((prevData: any) => {
            return { ...prevData, type4: response?.data?.count };
          });
        }
      }
    } catch (error: any) {
      console.log("error :", error);
      showError(error?.data?.message);
    }
  };

  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
    if (newValue == 3) {
      setCancelTravelCount(0);
      readCancelShipmentNotification();
    }
  };

  const getFilteredTravelers = (
    searchTerm: string,
    startDate: any,
    endDate: any
  ) => {
    const formatDate = (date: any) =>
      new Date(Date.parse(date) + 24 * 60 * 60 * 1000)
        .toISOString()
        .slice(0, 10);

    const isWithinDateRange = (data: any) => {
      if (!startDate || !endDate) return true;

      const start = formatDate(startDate);
      const end = formatDate(endDate);

      const firstDate = data?.travelDetail?.[0]?.departureDate?.slice(0, 10);
      const lastDate = data?.travelDetail?.[
        data?.travelDetail.length - 1
      ]?.departureDate?.slice(0, 10);

      return firstDate >= start && lastDate <= end;
    };

    const matchesSearchTerm = (data: any) => {
      const fullName = data?.userDetails?.[0]?.fullName?.toLowerCase() || "";
      const travelId = `TR${data?.travelId}`.toLowerCase();
      const email = data?.userDetails?.[0]?.email?.toLowerCase() || "";
      const term = searchTerm.toLowerCase();

      return (
        fullName.includes(term) ||
        travelId.includes(term) ||
        email.includes(term) ||
        !searchTerm
      );
    };

    const matchesDepartureCity = (data: any) =>
      selectedDepartureCities.length == 0 ||
      selectedDepartureCities.some(
        (item: any) => data?.currentAddress?.addressId == item.id
      );

    const matchesArrivalCity = (data: any) =>
      selectedArrivalCities.length == 0 ||
      selectedArrivalCities.some(
        (item: any) =>
          data?.destinationAddress?.[data?.destinationAddress?.length - 1]
            ?.addressId == item.id
      );

    return travelers?.filter((data: any) => {
      const matchDate = isWithinDateRange(data);
      const matchSearch = searchTerm == "" || matchesSearchTerm(data);
      const matchDeparture = matchesDepartureCity(data);
      const matchArrival = matchesArrivalCity(data);

      // Show only if all filters match
      console.log(
        "matchDate && matchSearch && matchDeparture && matchArrival :",
        matchDate,
        matchSearch,
        matchDeparture,
        matchArrival
      );
      return matchDate && matchSearch && matchDeparture && matchArrival;
    });
  };

  const [columnVisibilityModel1, setColumnVisibilityModel1] = useState<any>({
    name: true,
    passportId: true,
    ticketVehicleReg: true,
    arrivalCityDate: true,
    mobile: true,
    email: true,
    residencyType: true,
    currentCity: true,
    departureCityDate: true,
    travelNo: true,
    action:
      secureLocalStorage.getItem("role") == ADMIN_ROLE_ID ||
      (secureLocalStorage?.getItem("permissions") &&
        secureLocalStorage?.getItem("permissions") !== "undefined" &&
        JSON.parse(
          (secureLocalStorage?.getItem("permissions") as string) || ""
        )?.[0]?.isEdit)
        ? true
        : false,
  });
  const [columnVisibilityModel2, setColumnVisibilityModel2] = useState<any>({
    TR: true,
    name: true,
    availableWeight: true,
    arrivalCityDate: true,
    mobile: true,
    approveDate: true,
    status: true,
    currentCity: true,
    departureCityDate: true,
    wayOfTravel: true,
    viewProfile: true,
    email: true,
    action:
      secureLocalStorage.getItem("role") == ADMIN_ROLE_ID ||
      (secureLocalStorage?.getItem("permissions") &&
        secureLocalStorage?.getItem("permissions") !== "undefined" &&
        JSON.parse(
          (secureLocalStorage?.getItem("permissions") as string) || ""
        )?.[0]?.isEdit)
        ? true
        : false,
  });
  const [columnVisibilityModel3, setColumnVisibilityModel3] = useState<any>({
    name: true,
    residencyType: true,
    ticketVehicleReg: true,
    email: true,
    passportId: true,
    currentCity: true,
    travelNo: true,
    action:
      secureLocalStorage.getItem("role") == ADMIN_ROLE_ID ||
      (secureLocalStorage?.getItem("permissions") &&
        secureLocalStorage?.getItem("permissions") !== "undefined" &&
        JSON.parse(
          (secureLocalStorage?.getItem("permissions") as string) || ""
        )?.[0]?.isEdit)
        ? true
        : false,
  });
  const [searchTerm, setSearchTerm] = useState("");
  // const[searchTerm2,setSearchTerm2]=useState("");
  // const[searchTerm3,setSearchTerm3]=useState("");

  const [departureCity, setDepartureCity] = useState("");
  const [arrivalCity, setArrivalCity] = useState("");

  // const lastColumn = columns.pop();
  //

  //   let hidden = []

  //

  useEffect(() => {
    getAllDataList();
    getAllDataListTotalCount(1);
    getAllDataListTotalCount(2);
    getAllDataListTotalCount(3);
    getAllDataListTotalCount(4);
  }, []);
  useEffect(() => {
    setType(valueTabs + 1);
    setSearchTerm("");
    setTravelers([]);
    setDateValue(["", ""]);
  }, [valueTabs]);
  useEffect(() => {
    getAllDataList();
    setSelectedRow((prevData: any) => {
      return { ...prevData, row: [] };
    });
    setSelectedDepartureCities([]);
    setSelectedArrivalCities([]);
    setDateValue([null, null]);
  }, [type]);
  return (
    <>
      <Loader isLoad={isLoading} />
      <div className="main_title">
        <h1>
          List of Travelers
          {`(${
            (totalDataCount?.type1 ?? 0) +
            (totalDataCount?.type2 ?? 0) +
            (totalDataCount?.type3 ?? 0)
            //  +(totalDataCount?.type4 ?? 0)
          } Traveler${
            (totalDataCount?.type1 ?? 0) +
              (totalDataCount?.type2 ?? 0) +
              (totalDataCount?.type3 ?? 0) >
            // +(totalDataCount?.type4 ?? 0)
            1
              ? "s"
              : ""
          })`}
          {/* {`(${totalTravelCount} Traveler${totalTravelCount > 1 ? "s" : ""})`} */}
        </h1>
        <p>
          <span onClick={() => navigate("/dashboard")}>Dashboard</span> -
          Registrations - Travelers
        </p>
      </div>
      <div className="cards">
        <Box className="custom_tabs" sx={{ width: "100%" }}>
          <CustomTabPanel value={valueTabs} index={0}>
            <NewTravelersFilter
              gridApi={gridApi}
              setSelectedDepartureCities={setSelectedDepartureCities}
              setSelectedArrivalCities={setSelectedArrivalCities}
              setArrivalCities={setArrivalCities}
              setDepartureCities={setDepartureCities}
              arrivalCities={arrivalCities}
              departureCities={departureCities}
              dateValue={dateValue}
              setDateValue={setDateValue}
              selectedRow={selectedRow}
              setSearchTerm={setSearchTerm}
              columnVisibilityModel={columnVisibilityModel1}
              setColumnVisibilityModel={setColumnVisibilityModel1}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <ApprovedTravelersFilter
              setSelectedDepartureCities={setSelectedDepartureCities}
              setSelectedArrivalCities={setSelectedArrivalCities}
              setArrivalCities={setArrivalCities}
              setDepartureCities={setDepartureCities}
              arrivalCities={arrivalCities}
              departureCities={departureCities}
              gridApi={gridApi}
              selectedRow={selectedRow}
              searchTerm={searchTerm}
              dateValue={dateValue}
              setDateValue={setDateValue}
              setSearchTerm={setSearchTerm}
              columnVisibilityModel={columnVisibilityModel2}
              setColumnVisibilityModel={setColumnVisibilityModel2}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <RejectedTravelersFilter
              gridApi={gridApi}
              setSelectedDepartureCities={setSelectedDepartureCities}
              setSelectedArrivalCities={setSelectedArrivalCities}
              setArrivalCities={setArrivalCities}
              setDepartureCities={setDepartureCities}
              arrivalCities={arrivalCities}
              departureCities={departureCities}
              selectedRow={selectedRow}
              searchTerm={searchTerm}
              dateValue={dateValue}
              setDateValue={setDateValue}
              setSearchTerm={setSearchTerm}
              columnVisibilityModel={columnVisibilityModel3}
              setColumnVisibilityModel={setColumnVisibilityModel3}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <RejectedTravelersFilter
              gridApi={gridApi}
              setSelectedDepartureCities={setSelectedDepartureCities}
              setSelectedArrivalCities={setSelectedArrivalCities}
              setArrivalCities={setArrivalCities}
              setDepartureCities={setDepartureCities}
              arrivalCities={arrivalCities}
              departureCities={departureCities}
              selectedRow={selectedRow}
              searchTerm={searchTerm}
              dateValue={dateValue}
              setDateValue={setDateValue}
              setSearchTerm={setSearchTerm}
              columnVisibilityModel={columnVisibilityModel3}
              setColumnVisibilityModel={setColumnVisibilityModel3}
            />
          </CustomTabPanel>

          <Tabs
            value={valueTabs}
            onChange={handleChangeTabs}
            aria-label="basic tabs example"
            className="custom_tabs_links"
          >
            <Tab
              label={"New Travelers (" + totalDataCount?.type1 + ")"}
              {...a11yProps(0)}
            />
            <Tab
              label={"Approved Travelers (" + totalDataCount?.type2 + ")"}
              {...a11yProps(1)}
            />
            <Tab
              label={"Rejected Travelers (" + totalDataCount?.type3 + ")"}
              {...a11yProps(2)}
            />
            <Tab
              label={"Cancelled Travelers (" + totalDataCount?.type4 + ")"}
              icon={
                cancelTravelCount ? (
                  <Tooltip title={`${cancelTravelCount} shipment cancelled`}>
                    <Info style={{ color: "red", marginLeft: 0 }} />
                  </Tooltip>
                ) : undefined
              }
              iconPosition="end"
              {...a11yProps(2)}
            />
          </Tabs>

          <CustomTabPanel value={valueTabs} index={0}>
            <NewTravelersList
              setTotalDataCount={setTotalDataCount}
              getDataList={getAllDataList}
              gridApi={gridApi}
              setSelectedRow={setSelectedRow}
              columnVisibilityModel={columnVisibilityModel1}
              travelers={getFilteredTravelers(
                searchTerm,
                dateValue?.[0]?.["$d"] &&
                  new Date(dateValue?.[0]?.["$d"])?.toISOString(),
                dateValue?.[1]?.["$d"] &&
                  new Date(dateValue?.[1]?.["$d"])?.toISOString()
              )}
              hidden={hidden}
              openModal={openModal}
              setOpenModal={setOpenModal}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={1}>
            <ApprovedTravelersList
              getDataList={getAllDataList}
              gridApi={gridApi}
              setSelectedRow={setSelectedRow}
              columnVisibilityModel={columnVisibilityModel2}
              travelers={getFilteredTravelers(
                searchTerm,
                dateValue?.[0]?.["$d"] &&
                  new Date(dateValue?.[0]?.["$d"])?.toISOString(),
                dateValue?.[1]?.["$d"] &&
                  new Date(dateValue?.[1]?.["$d"])?.toISOString()
              )}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={2}>
            <RejectedTravelersList
              rejected={true}
              setTotalDataCount={setTotalDataCount}
              getDataList={getAllDataList}
              gridApi={gridApi}
              setSelectedRow={setSelectedRow}
              columnVisibilityModel={columnVisibilityModel3}
              travelers={getFilteredTravelers(
                searchTerm,
                dateValue?.[0]?.["$d"] &&
                  new Date(dateValue?.[0]?.["$d"])?.toISOString(),
                dateValue?.[1]?.["$d"] &&
                  new Date(dateValue?.[1]?.["$d"])?.toISOString()
              )}
            />
          </CustomTabPanel>
          <CustomTabPanel value={valueTabs} index={3}>
            <RejectedTravelersList
              rejected={false}
              setTotalDataCount={setTotalDataCount}
              getDataList={getAllDataList}
              gridApi={gridApi}
              setSelectedRow={setSelectedRow}
              columnVisibilityModel={columnVisibilityModel3}
              travelers={getFilteredTravelers(
                searchTerm,
                dateValue?.[0]?.["$d"] &&
                  new Date(dateValue?.[0]?.["$d"])?.toISOString(),
                dateValue?.[1]?.["$d"] &&
                  new Date(dateValue?.[1]?.["$d"])?.toISOString()
              )}
            />
          </CustomTabPanel>
        </Box>
      </div>
    </>
  );
};

export default Travelers;
